import { OptionType } from 'components';

export enum EmploymentStatus {
    Actif = '2',
    CongeNonPaye = '3',
    CongePaye = '4',
    Chomage = '5',
    CongeDeConversion = '6',
    Demission = '7',
    AppelSousLesDrapeaux = '8',
    Licenciement = '9',
}
// Array of employment status options

export const employmentStatusOptions: OptionType[] = [
    { value: EmploymentStatus.Actif, label: 'Actif' },
    { value: EmploymentStatus.CongeNonPaye, label: 'Congé non payé' },
    { value: EmploymentStatus.CongePaye, label: 'Congé payé' },
    { value: EmploymentStatus.Chomage, label: 'Chômage' },
    { value: EmploymentStatus.CongeDeConversion, label: 'Congé de conversion' },
    { value: EmploymentStatus.Demission, label: 'Démission' },
    { value: EmploymentStatus.AppelSousLesDrapeaux, label: 'Appel sous les drapeaux' },
    { value: EmploymentStatus.Licenciement, label: 'Licenciement' },
]; // Enum for the provided options

export enum AllocationType {
    AllocationMaterniteRisquesParticuliers = 'AMRP',
    AllocationMaterniteTravailDeNuit = 'AMTN',
    AccidentDuTravail = 'AT',
    Maladie = 'MAL',
    Maternite = 'MAT',
    MaladieProfessionnelle = 'MP',
    Paternite = 'PAT',
    AutreCas = 'AUT',
    ChomageTotalOuPartiel = 'CHOM',
    CongesPayes = 'COP',
    FermetureDeLEtablissement = 'FERM',
    NouvelleEmbauche = 'NEMB',
    JourneeDAppelALaDefense = 'SN',
    TempsPartielTherapeutique = 'TPT',
    AbsenceAutorisee = 'ABA',
}
// Array of allocation options

export const allocationOptions: OptionType[] = [
    { value: AllocationType.AllocationMaterniteRisquesParticuliers, label: 'Allocation maternité / Risques particuliers' }, // S3201
    { value: AllocationType.AllocationMaterniteTravailDeNuit, label: 'Allocation maternité / Travail de nuit' }, // S3201
    { value: AllocationType.AccidentDuTravail, label: 'Accident du travail' }, // S6202
    { value: AllocationType.Maladie, label: 'Maladie' }, // S3201 S3202
    { value: AllocationType.Maternite, label: 'Maternité' }, // S3201
    { value: AllocationType.MaladieProfessionnelle, label: 'Maladie professionnelle' }, // S6202
    { value: AllocationType.Paternite, label: 'Paternité' }, // S3201
    { value: AllocationType.AutreCas, label: 'Autre cas' },
    { value: AllocationType.ChomageTotalOuPartiel, label: 'Chômage total ou partiel' },
    { value: AllocationType.CongesPayes, label: 'Congés payés' },
    { value: AllocationType.FermetureDeLEtablissement, label: 'Fermeture de l’établissement' },
    { value: AllocationType.NouvelleEmbauche, label: 'Nouvelle embauche' },
    { value: AllocationType.JourneeDAppelALaDefense, label: 'Journée d’appel à la défense' },
    { value: AllocationType.TempsPartielTherapeutique, label: 'Temps partiel thérapeutique' },
    { value: AllocationType.AbsenceAutorisee, label: 'Absence autorisée' },
];
